/**
 * Écritures tables normalisées depuis le store (mutations directes + push debouncé).
 */
import { supabase } from "./supabase";
import { isSupabaseReady } from "./supabase";
import { upsertClient, upsertEvent, upsertProduct } from "./supabasePersistence";
import { clientAppToDbRow, eventAppToDbRow, productAppToDbRow } from "../utils/supabaseRowMappers";

export function shouldWriteRemote(coachId) {
  return isSupabaseReady(coachId);
}

export async function upsertClientApp(client, coachId) {
  if (!shouldWriteRemote(coachId)) return { ok: true, local: true };
  const row = clientAppToDbRow(client, coachId);
  if (!row) return { ok: true, skipped: true };
  const { error } = await upsertClient(row);
  return { ok: !error, error };
}

export async function upsertEventApp(event, coachId) {
  if (!shouldWriteRemote(coachId)) return { ok: true, local: true };
  const row = eventAppToDbRow(event, coachId);
  if (!row) return { ok: true, skipped: true };
  const { error } = await upsertEvent(row);
  return { ok: !error, error };
}

export async function upsertProductApp(product, coachId) {
  if (!shouldWriteRemote(coachId)) return { ok: true, local: true };
  const row = productAppToDbRow(product, coachId);
  if (!row) return { ok: true, skipped: true };
  const { error } = await upsertProduct(row);
  return { ok: !error, error };
}

/** Upsert plusieurs events (séries, extension). */
export async function upsertEventsApp(events, coachId) {
  if (!shouldWriteRemote(coachId)) return { ok: true, local: true };
  const rows = events.map((e) => eventAppToDbRow(e, coachId)).filter(Boolean);
  if (!rows.length) return { ok: true, skipped: true };
  const { error } = await supabase.from("events").upsert(rows, { onConflict: "id" });
  return { ok: !error, error };
}

export function allOk(results) {
  return results.every((r) => !r || r.ok !== false);
}
